// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.lifecycle-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 8px 0;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 0.9rem;
}
.lifecycle-notice.lifecycle-notice--warning {
  color: #e65100;
  background-color: #fff3e0;
  border: 1px solid #faab18;
}
.lifecycle-notice.lifecycle-notice--info {
  color: #8c8f93;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
